import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=5a5a27bb&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=5a5a27bb&prod&scoped=true&lang=css"
import style1 from "./editor.vue?vue&type=style&index=1&id=5a5a27bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5a27bb",
  null
  
)

export default component.exports